module.exports = __webpack_public_path__ + "img/charge_car1.6e2d4746.png";